export default __webpack_public_path__ + "static/media/diamond@2x.4d75d3e1.png";